import * as z from 'zod';

import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

export const emergencyContactQuerySchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  relationship: z.string().nullable(),
  email: z.string().nullable(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
});

export type EmergencyContactQuerySchema = z.infer<typeof emergencyContactQuerySchema>;
